export const CorporateTimelineSteps = [
  {
    id: 1,
    name: "Add Organisation",
    subsections: [
      {
        id: "1a",
        name: "Organisation"
      }
    ]
  },
  {
    id: 2,
    name: "Select a Subscription",
    subsections: [
      {
        id: "2a",
        name: "Subscription"
      }
    ]
  },
  {
    id: 3,
    name: "Add a Participant",
    subsections: [
      {
        id: "3a",
        name: "Participant Info"
      }
    ]
  },
  {
    id: 4,
    name: "Add Wallet",
    subsections: [
      {
        id: "4a",
        name: "Wallet Info"
      }
    ]
  }
];

export const IndividualTimelineSteps = [
  {
    id: 1,
    name: "Create Admin Account",
    subsections: [
      {
        id: "1a",
        name: "Participant Detail"
      }
    ]
  },
  {
    id: 2,
    name: "Select a Subscription",
    subsections: [
      {
        id: "2a",
        name: "Subscription"
      }
    ]
  },
  {
    id: 3,
    name: "Confirm Participant Detail",
    subsections: [
      {
        id: "3a",
        name: "Participant Info"
      }
    ]
  },
  {
    id: 4,
    name: "Add Wallet",
    subsections: [
      {
        id: "4a",
        name: "Wallet Info"
      }
    ]
  }
];

export const RefererTimelineSteps = [
  {
    id: 1,
    name: "Create Referer Account",
    subsections: [
      {
        id: "1a",
        name: "Referer Detail"
      }
    ]
  }
];
